/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VccCredentialsListItem,
    VccCredentialsListItemFromJSON,
    VccCredentialsListItemFromJSONTyped,
    VccCredentialsListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsListItemPaginationWrapper
 */
export interface VccCredentialsListItemPaginationWrapper {
    /**
     * 
     * @type {Array<VccCredentialsListItem>}
     * @memberof VccCredentialsListItemPaginationWrapper
     */
    items?: Array<VccCredentialsListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof VccCredentialsListItemPaginationWrapper
     */
    totalItems?: number;
}

export function VccCredentialsListItemPaginationWrapperFromJSON(json: any): VccCredentialsListItemPaginationWrapper {
    return VccCredentialsListItemPaginationWrapperFromJSONTyped(json, false);
}

export function VccCredentialsListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(VccCredentialsListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function VccCredentialsListItemPaginationWrapperToJSON(value?: VccCredentialsListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(VccCredentialsListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


